import Glide from '@glidejs/glide'

export default class SukuCarousel extends HTMLElement {
  constructor() {
    super()

    this.cursor = ''

    const container = this.querySelector('.glide')
    
    this.glide = new Glide(container, {
      type: 'carousel',
      gap: 0,
      classes: {
        activeNav: 'glide__bullet--active font-bold',
      }
    }).mount()
  }
}

customElements.define('suku-carousel', SukuCarousel)

